import React, { memo } from 'react';
import cn from 'classnames';
import IconArrowLeftBold from '@creditflowresearch/uilib/Icon/IconArrowLeftBold';
import styles from './tableYearsNavArrows.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface IProps {
  isDisabled: boolean,
  decreaseTablePosition: () => void,
}

const TableYearsNavArrowsLeft = ({ isDisabled = true, decreaseTablePosition }:IProps) => {
  const wrapperClass = cn(
    styles.navTableArrow,
    {
      [styles.lastPosition]: isDisabled,
    },
  );

  return (
    <IconButton
      icon={ <IconArrowLeftBold size={ 12 } /> }
      className={ wrapperClass }
      onClick={ decreaseTablePosition }
      dataTest="tableYearsNavArrowDecreaseButton"
      ariaLabel="Show earlier years"
    />
  );
};

export default memo(TableYearsNavArrowsLeft);
